import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import * as yup from "yup";
import { connect } from "react-redux";
import { DialogActions, TextField } from "@material-ui/core";
import { Link, Redirect } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../../store/ducks/auth.duck";
import { useGlobalData } from "../../../provider/GlobalDataProvider";
import Swal from "sweetalert2";
import { forgotPassword } from "../../services/authService";
import { onPreventEnterSubmitting } from "../../utils/utils";
import { FormTextField } from "../../partials/content/Forms/FormField";

function ForgotPassword({ onCloseDialog }) {
  const { reload } = useGlobalData();
  const [emailData, setEmailData] = useState({
    email: "",
  });

  useEffect(() => {
    return () => {
      setEmailData({
        email: "",
      });
    };
  }, [reload]);

  const emailFormSchema = yup.object().shape({
    email: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
  });

  return (
    <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h3>
              <FormattedMessage id="AUTH.FORGOT.TITLE" />
            </h3>
            <h6>We will send the new password to your email below.</h6>
          </div>
          <Formik
            initialValues={emailData}
            validationSchema={emailFormSchema}
            enableReinitialize={true}
            onSubmit={async (values, { setStatus, setSubmitting }) => {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              })
                .fire({
                  title:
                    "Are you sure want to send the resetting password to this Email ?",
                  text: "Please note that you are responsible for this action",
                  icon: "question",
                  showCloseButton: true,
                  showCancelButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, reset it`,
                  cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    forgotPassword(values).then((response) => {
                      Swal.mixin({
                        customClass: {
                          confirmButton:
                            "btn btn-success btn-md btn-pill btn-bold",
                        },
                        buttonsStyling: false,
                      }).fire({
                        title: "Resetted",
                        html: response.data.message,
                        icon: "success",
                        showCloseButton: true,
                        confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                      });
                      onCloseDialog();
                    });
                  } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.mixin({
                      customClass: {
                        confirmButton:
                          "btn btn-success btn-md btn-pill btn-bold",
                      },
                      buttonsStyling: false,
                    }).fire({
                      title: "Cancelled",
                      text: "No change has been made",
                      icon: "info",
                      showCloseButton: true,
                      confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                    });
                  }
                });
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
                onKeyDown={onPreventEnterSubmitting}
              >
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <FormTextField label="Email" name="email" />
                  </div>
                </div>
                <DialogActions>
                  <button
                    type="button"
                    className="btn btn-label-danger btn-md btn-pill btn-bold"
                    onClick={onCloseDialog}
                  >
                    <i className="fas fa-window-close"></i>
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-success btn-md btn-pill btn-bold"
                    disabled={isSubmitting}
                  >
                    <i className="fas fa-key"></i>
                    Reset
                  </button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(ForgotPassword));
